<template>
	<div class="app-container">
		<div class="common-section-bg status-board">
			<div class="status-board__header">
				<div>
					<div class="status-board__title-wrap">
						<div class="status-board__title">车辆日期排期表</div>
						<el-button class="refresh-btn" size="mini" @click="refreshStatusTable">刷新</el-button>
						<el-input
							v-model="maxDate"
							size="mini"
							class="max-date-input"
							placeholder="最大可预约天数"
							@keyup.enter.native="submitMaxDate"
						>
							<template slot="append">
								<el-button class="max-date-submit-btn" type="text" @click="submitMaxDate">提交</el-button>
							</template>
						</el-input>
					</div>
					<div class="status-board__desc">展示今天及之后的连续{{maxDate}}天内，车辆的使用情况</div>
				</div>
				<div class="status-board__legend">
					<span class="legend-item">
						<i class="legend-dot legend-dot--free" />
						空闲
					</span>
					<span class="legend-item">
						<i class="legend-dot legend-dot--busy" />
						繁忙
					</span>
				</div>
			</div>

			<el-table
				:data="carStatusTable"
				size="mini"
				border
				stripe
				class="status-table"
				style="width: 100%"
			>
				<el-table-column
					prop="carName"
					label="车辆"
					fixed="left"
					min-width="140"
					align="center"
				/>
				<el-table-column
					v-for="column in dateColumns"
					:key="column.key"
					:label="column.label"
					:min-width="110"
					align="center"
				>
					<template slot-scope="scope">
						<span
							class="status-chip"
							:class="[
								scope.row[column.key] === '空闲' ? 'status-chip--free' : 'status-chip--busy',
								'status-chip--clickable'
							]"
							@click="handleStatusCellClick(scope.row, column)"
						>
							{{ scope.row[column.key] }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" min-width="120" align="center">
					<template slot-scope="scope">
						<el-button
							type="warning"
							size="mini"
							@click="openCalendarDrawer(scope.row)"
						>
							预约日历
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-drawer
			custom-class="custom-drawer"
			:visible.sync="showCalendarDrawer"
			:close-on-press-escape="false"
			:wrapper-closable="false"
			:show-close="false"
			size="800px"
		>
			<template slot="title">
				<div class="custom-title">
					<div class="title-name">车辆预约日历 - {{ currentCar ? currentCar.name : '' }}</div>
					<i class="el-icon-circle-close close-btn pointer" @click="closeCalendarDrawer" />
				</div>
			</template>
			<div class="custom-content">
				<div class="calendar-container">
					<div class="calendar-header">
						<el-button @click="prevMonth" icon="el-icon-arrow-left">上个月</el-button>
						<span class="current-month">{{ currentMonth.getFullYear() }}年{{ currentMonth.getMonth() + 1 }}月</span>
						<el-button @click="nextMonth" icon="el-icon-arrow-right">下个月</el-button>
					</div>
					<el-calendar v-model="currentMonth">
						<template slot="dateCell" slot-scope="{data}">
							<el-tooltip
								effect="dark"
								placement="top"
								popper-class="calendar-booked-tooltip"
								:disabled="!isBooked(data.day)"
							>
								<div slot="content" class="calendar-booked-tooltip-content">
									<div>姓名：{{ getBookedName(data.day) }}</div>
									<div>手机号：{{ getBookedPhone(data.day) }}</div>
									<div>备注：{{ getBookedRemark(data.day) }}</div>
								</div>
								<div
									class="calendar-day"
									:class="{ 'calendar-day-clickable': isAvailableDay(data.day, data) }"
									@click.stop="handleDayCellClick(data)"
								>
									<p>{{ data.day.split('-').slice(2).join('-') }}</p>
									<template v-if="isCurrentMonthCell(data)">
										<div v-if="isBooked(data.day)" class="booked">已预约</div>
										<div v-else-if="isUnavailableDay(data.day, data)" class="unavailable">不可预约</div>
										<div v-else class="available">可预约</div>
									</template>
								</div>
							</el-tooltip>
						</template>
					</el-calendar>
				</div>
			</div>
		</el-drawer>
		<!-- 预约编辑抽屉 -->
		<el-drawer
			:visible.sync="showRiliDrawer"
			:append-to-body="true"
			size="400px"
			:title="riliEditMode ? '编辑预约' : '预约车辆'"
		>
			<el-form ref="riliForm" class="rili-form" :model="riliData" :rules="riliRules" label-width="100px">
				<el-form-item label="车名称">
					<el-input v-model="riliData.carName" disabled />
				</el-form-item>
				<el-form-item label="预约日期">
					<el-input v-model="riliData.date" disabled />
				</el-form-item>
				<el-form-item label="姓名" prop="name">
					<el-input v-model="riliData.name" />
				</el-form-item>
				<el-form-item label="联系方式" prop="phone">
					<el-input v-model="riliData.phone" />
				</el-form-item>
				<el-form-item label="备注" prop="beizhu">
					<el-input v-model="riliData.beizhu" type="textarea" />
				</el-form-item>
				<div class="rili-action-btns">
					<el-button v-if="riliEditMode" class="rili-delete-btn" @click="removeRiliOrder">删除</el-button>
					<div class="rili-action-right">
						<el-button type="primary" :loading="riliSubmitting" @click="submitRiliOrder">{{ riliEditMode ? '修改' : '提交' }}</el-button>
					</div>
				</div>
			</el-form>
		</el-drawer>
	</div>
</template>

<script>
import fetch from "@/api/tianzheng/yuyueche";

export default {
	name: "YuyueRili",
	data() {
		return {
			dayCount: 15,
			maxDate: "",
			carCount: 10,
			dateColumns: [],
			carStatusTable: [],
			showCalendarDrawer: false,
			currentCar: null,
			calendarData: [],
			currentMonth: new Date(),
			calendarRequestSeq: 0,
			showRiliDrawer: false,
			riliEditMode: false,
			riliSubmitting: false,
			riliData: {
				id: "",
				carId: "",
				carName: "",
				date: "",
				name: "",
				phone: "",
				beizhu: "",
			},
			riliRules: {
				name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
				phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
			},
		};
	},
	created() {
		this.initPageData();
	},
	watch: {
		currentMonth(val) {
			if (!val || !this.showCalendarDrawer || !this.currentCar) return;
			this.loadCalendarData(val);
		},
	},
	methods: {
		initPageData() {
			fetch
				.riqidata15({
					maxDate: "",
				})
				.then((res) => {
					if (res.code === 200) {
						this.maxDate = (res.result && res.result.max_date) || this.maxDate;
					}
				})
				.finally(() => {
					this.buildStatusTable();
				});
		},
		submitMaxDate() {
			this.refreshStatusTable();
		},
		refreshStatusTable() {
			this.buildStatusTable();
		},
		buildStatusTable() {
			this.dateColumns = this.buildDateColumns();
			this.carStatusTable = this.buildCarRows();
		},
		buildDateColumns() {
			const columns = [];
			const today = new Date();
			const dayCount = this.getEffectiveDayCount();

			for (let index = 0; index < dayCount; index += 1) {
				const currentDate = new Date(today);
				currentDate.setDate(today.getDate() + index);
				const month = this.padNumber(currentDate.getMonth() + 1);
				const day = this.padNumber(currentDate.getDate());

				columns.push({
					key: `day${index}`,
					label: `${month}-${day}`,
					rawDate: this.formatDate(currentDate),
				});
			}

			return columns;
		},
		buildCarRows() {
			const rows = [];
			this.carStatusTable = [];
            fetch.riqidata15({
				maxDate: this.maxDate,
            }).then((res) => {
                if (res.code === 200) {
                    // 数据是一个数组，包含车辆的预约信息
                    const carsArr = res.result.list || [];
					this.maxDate = res.result.max_date || "";
					this.dayCount = this.getEffectiveDayCount();
                    this.carCount = carsArr.length;
                    for (let carIndex = 0; carIndex < this.carCount; carIndex += 1) {
                        const carData = carsArr[carIndex];
                        const carOneInfo = carData.car_info;
                        const carDateList = carData.appointments;
                        const row = {
                            id: carOneInfo.id,
                            carName: carOneInfo.name,
							appointmentList: carDateList || [],
                        };
                        this.dateColumns.forEach((column, dateIndex) => {
                            // 根据实际数据结构调整这里的逻辑  
                            const dateKey = column.rawDate;
							const isBooked = carDateList && carDateList.some(app => this.normalizeCalendarDay(app.appointment_date || app.date) === dateKey);
                            row[column.key] = isBooked ? "繁忙" : "空闲";
                        });

                        rows.push(row);
                    }
					this.carStatusTable = rows;
                    return rows;
                } else {
                    this.$message.error("获取车辆数据失败");
                    return rows;
                }
                
            }).catch(() => {
                this.$message.error("获取车辆数据失败");
            });

			
		},
		getStatusByIndex(carIndex, dateIndex) {
			return (carIndex + dateIndex) % 3 === 0 || dateIndex % 5 === 4 ? "繁忙" : "空闲";
		},
		formatDate(date) {
			const year = date.getFullYear();
			const month = this.padNumber(date.getMonth() + 1);
			const day = this.padNumber(date.getDate());
			return `${year}-${month}-${day}`;
		},
		getEffectiveDayCount() {
			const parsed = Number(this.maxDate +1);
			if (Number.isFinite(parsed) && parsed > 0) {
				return Math.floor(parsed);
			}
			return this.dayCount > 0 ? this.dayCount : 15;
		},
		padNumber(value) {
			return String(value).padStart(2, "0");
		},
		handleStatusCellClick(row, column) {
			if (!row || !column) return;
			this.currentCar = {
				id: row.id,
				name: row.carName,
			};
			this.calendarData = row.appointmentList || [];
			const day = column.rawDate;
			if (row[column.key] === "繁忙") {
				this.openRiliDrawer(day, true);
				return;
			}
			this.openRiliDrawer(day, false);
		},
		openCalendarDrawer(row) {
			this.currentCar = {
				id: row.id,
				name: row.carName,
			};
			this.showCalendarDrawer = true;
			this.loadCalendarData();
		},
		closeCalendarDrawer() {
			this.showCalendarDrawer = false;
			this.currentCar = null;
			this.calendarData = [];
		},
		loadCalendarData(targetMonth) {
			if (!this.currentCar) return;
			const queryMonth = targetMonth || this.currentMonth;
			const year = queryMonth.getFullYear();
			const month = queryMonth.getMonth() + 1;
			const requestSeq = ++this.calendarRequestSeq;
			fetch.riqidata({
				cheId: this.currentCar.id,
				year: year,
				month: month,
			}).then((res) => {
				if (requestSeq !== this.calendarRequestSeq) return;
				if (res.code == 200) {
					this.calendarData = (res.result && res.result.list) || [];
				} else {
					this.$message.error(res.message);
				}
			});
		},
		prevMonth() {
			const prev = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
			this.currentMonth = prev;
		},
		nextMonth() {
			const next = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
			this.currentMonth = next;
		},
		isBooked(day) {
			return this.calendarData.some((item) => this.normalizeCalendarDay(item.appointment_date || item.date) === day);
		},
		getBookedInfo(day) {
			return this.calendarData.find((item) => this.normalizeCalendarDay(item.appointment_date || item.date) === day) || null;
		},
		normalizeCalendarDay(day) {
			if (!day) return "";
			return String(day).split(" ")[0].split("T")[0];
		},
		getAppointmentField(record, fields) {
			if (!record) return "--";
			const field = fields.find((key) => record[key] !== undefined && record[key] !== null && record[key] !== "");
			return field ? record[field] : "--";
		},
		getBookedName(day) {
			return this.getAppointmentField(this.getBookedInfo(day), ["name", "userName", "appointment_name"]);
		},
		getBookedPhone(day) {
			return this.getAppointmentField(this.getBookedInfo(day), ["contact", "phone", "mobile"]);
		},
		getBookedRemark(day) {
			return this.getAppointmentField(this.getBookedInfo(day), ["beizhu", "remark", "remarks", "appointment_remark"]);
		},
		getBookedId(day) {
			return this.getAppointmentField(this.getBookedInfo(day), ["id", "riliId", "appointment_id"]);
		},
		isCurrentMonthCell(data) {
			return data && data.type === "current-month";
		},
		isUnavailableDay(day, data) {
			return this.isCurrentMonthCell(data) && !this.isBooked(day) && this.isPastDay(day);
		},
		isAvailableDay(day, data) {
			return this.isCurrentMonthCell(data) && !this.isBooked(day) && !this.isPastDay(day);
		},
		handleDayCellClick(data) {
			if (!this.isCurrentMonthCell(data)) return;
			const day = data.day;
			if (this.isBooked(day)) {
				this.openRiliDrawer(day, true);
				return;
			}
			if (!this.isAvailableDay(day, data)) return;
			this.openRiliDrawer(day, false);
		},
		isPastDay(day) {
			const targetDate = new Date(`${day} 00:00:00`);
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			return targetDate < today;
		},
		openRiliDrawer(day, isEdit = false) {
			if (!isEdit && this.isPastDay(day)) {
				this.$message.warning("今天之前的日期不可预约");
				return;
			}
			this.riliEditMode = isEdit;
			const bookedInfo = isEdit ? this.getBookedInfo(day) : null;
			this.riliData.carId = this.currentCar.id;
			this.riliData.carName = this.currentCar.name;
			this.riliData.date = day;
			this.riliData.id = bookedInfo ? this.getBookedId(day) : "";
			this.riliData.name = bookedInfo ? this.getBookedName(day) : "";
			this.riliData.phone = bookedInfo ? this.getBookedPhone(day) : "";
			this.riliData.beizhu = bookedInfo ? this.getBookedRemark(day) : "";
			this.riliSubmitting = false;
			this.showRiliDrawer = true;
		},
		handleRiliActionSuccess() {
			this.showRiliDrawer = false;
			this.riliEditMode = false;
			this.loadCalendarData();
			this.refreshStatusTable();
		},
		submitRiliOrder() {
			if (this.riliSubmitting) return;
			this.$refs.riliForm.validate((valid) => {
				if (!valid) return;
				this.riliSubmitting = true;
				const params = {
					id: this.riliData.id,
					cheId: this.riliData.carId,
					date: this.riliData.date,
					name: this.riliData.name,
					phone: this.riliData.phone,
					contact: this.riliData.phone,
					beizhu: this.riliData.beizhu,
				};
				const submitApi = this.riliEditMode ? fetch.editRiliOrder : fetch.createRiliOrder;
				submitApi(params)
					.then((res) => {
						if (res.code === 200) {
							this.$message.success(this.riliEditMode ? "修改成功" : "预约成功");
							this.handleRiliActionSuccess();
						} else {
							this.$message.error(res.message);
						}
					})
					.catch(() => {
						this.$message.error("提交失败，请稍后重试");
					})
					.finally(() => {
						this.riliSubmitting = false;
					});
			});
		},
		removeRiliOrder() {
			if (!this.riliData.id || this.riliData.id === "--") {
				this.$message.warning("缺少预约ID，无法删除");
				return;
			}
			this.$confirm("确定删除该预约吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					fetch
						.removeRiliOrder({
							id: this.riliData.id,
							cheId: this.riliData.carId,
							date: this.riliData.date,
						})
						.then((res) => {
							if (res.code === 200) {
								this.$message.success("删除成功");
								this.handleRiliActionSuccess();
							} else {
								this.$message.error(res.message);
							}
						});
				})
				.catch(() => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.app-container {
	min-height: calc(100vh - 98px);
}

.status-board {
	padding: 20px;
	background: #fff;
	border-radius: 4px;
}

.status-board__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 16px;
	margin-bottom: 16px;
}

.status-board__title {
	font-size: 18px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 6px;
}

.status-board__title-wrap {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 6px;
	flex-wrap: wrap;
}

.max-date-input {
	width: 240px;
}

.max-date-submit-btn {
	padding: 0 10px;
}

.refresh-btn {
	background: #fff;
	color: #303133;
	border-color: #dcdfe6;
}

.refresh-btn:hover,
.refresh-btn:focus {
	background: #fff;
	color: #303133;
	border-color: #c0c4cc;
}

.status-board__desc {
	font-size: 13px;
	color: #909399;
}

.status-board__legend {
	display: flex;
	align-items: center;
	gap: 16px;
	flex-wrap: wrap;
}

.legend-item {
	display: inline-flex;
	align-items: center;
	color: #606266;
	font-size: 13px;
}

.legend-dot {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	margin-right: 6px;
}

.legend-dot--free {
	background: #67c23a;
}

.legend-dot--busy {
	background: #f56c6c;
}

.status-chip {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 56px;
	height: 28px;
	padding: 0 10px;
	border-radius: 14px;
	font-size: 12px;
	font-weight: 500;
}

.status-chip--clickable {
	cursor: pointer;
}

.status-chip--clickable:hover {
	opacity: 0.9;
}

.status-chip--free {
	color: #389e0d;
	background: #f6ffed;
	border: 1px solid #b7eb8f;
}

.status-chip--busy {
	color: #cf1322;
	background: #fff1f0;
	border: 1px solid #ffa39e;
}

.status-table ::v-deep .el-table__header th {
	background: #f5f7fa;
	color: #606266;
	font-weight: 600;
}

.calendar-container {
	padding: 20px;
}

.calendar-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
}

.current-month {
	font-size: 18px;
	font-weight: bold;
}

.calendar-day {
	text-align: center;
	min-height: 72px;
	padding: 6px 4px;
	border-radius: 6px;
}

.calendar-day-clickable {
	cursor: pointer;
}

.calendar-day-clickable:hover {
	background: #f5f9ff;
}

.booked {
	color: #f56c6c;
	font-size: 12px;
	margin-top: 5px;
}

.calendar-booked-tooltip-content {
	line-height: 1.8;
	min-width: 180px;
}

.rili-action-btns {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 10px;
	margin-top: 8px;
}

.rili-action-right {
	margin-left: auto;
}

.rili-form {
	margin-right: 12px;
}

.rili-delete-btn {
	background: #fff;
	color: #303133;
	border-color: #dcdfe6;
	margin-left: 10px;
}

.rili-delete-btn:hover,
.rili-delete-btn:focus {
	background: #fff;
	color: #303133;
	border-color: #c0c4cc;
	margin-left: 10px;
}

.available {
	color: #67c23a;
	font-size: 12px;
	margin-top: 5px;
}

.unavailable {
	color: #909399;
	font-size: 12px;
	margin-top: 5px;
}

@media (max-width: 768px) {
	.status-board {
		padding: 12px;
	}

	.status-board__header {
		flex-direction: column;
		align-items: flex-start;
	}
}
</style>
